import React from 'react';
import styles from '../../styles/common/StatusBadge.module.scss';

export type StatusType = 'pending' | 'compliant' | 'rejected' | 'active' | 'inactive' | 'success' | 'warning' | 'error';

interface StatusBadgeProps {
  status: StatusType;
  text?: string;
  size?: 'sm' | 'md' | 'lg';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ 
  status, 
  text, 
  size = 'md' 
}) => {
  const displayText = text || status.charAt(0).toUpperCase() + status.slice(1);

  return (
    <span 
      className={`${styles.statusBadge} ${styles[status]} ${styles[size]}`}
      data-status={status}
    >
      {displayText}
    </span>
  );
};

export default StatusBadge;
